module.exports = __webpack_public_path__ + "static/media/checkmarkOff_326.66a7d4c2.png";